var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveDownMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Send_down_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M10.874 19.877V4.123a1.125 1.125 0 012.251 0v15.754a1.125 1.125 0 11-2.251 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 5",
    d: "M7.06 16.046a1.125 1.125 0 011.923-.794L12 18.282l3.017-3.03a1.125 1.125 0 011.595 1.588l-3.815 3.831a1.125 1.125 0 01-1.595 0L7.388 16.84a1.122 1.122 0 01-.328-.794z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15112",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgMoveDownMobile;